export default __webpack_public_path__ + "static/media/schedule_resource_illustration.d74ab9d2.svg";